import type { VerticalGeneralSetupResponseDto } from "Infrastructure/Api/Api";

export type VerticalGeneralSetupResponseWithAllocation =
	VerticalGeneralSetupResponseDto & {
		allocationMaxDrivingDistanceKm?: number | null;
	};

export const getGeneralSetupFormData = (
	data: VerticalGeneralSetupResponseWithAllocation,
) => {
	return {
		adamServiceFeePercentage: data.adamServiceFeePercentage,
		adamServiceFeeVATPercentage: data.adamServiceFeeVATPercentage,
		customerVATPercentage: data.customerVATPercentage,
		depositPercentage: data.depositPercentage,
		depositLimitAmount: data.depositLimitAmount,
		staticDepositAmount: data.staticDepositAmount,
		expresFeePrice: data.expresFeePrice,
		emailReplyTo: data.emailReplyTo,
		dailyThreshold: data.dailyThreshold,
		allocationMaxDrivingDistanceKm: data.allocationMaxDrivingDistanceKm ?? null,
	};
};
